import { RVDebouncedInput, RVNestedPageHeader } from "@regal-voice/ui";
import { SettingsPaths } from "Pages/settings/paths";
import { SETTINGS_NAV_DESCRIPTIONS_PATCH, SETTINGS_NAV_TITLES } from "Pages/settings/settingsMetadata";
import { ToggleCollapsiblePanelButton, useKnownPanels } from "Utils/CollapsiblePanels";

type EventPageHeaderProps = {
    filterValue: string | undefined;
    setFilterValue: (value: string) => void;
};

export const EventPageHeader = ({ filterValue, setFilterValue }: EventPageHeaderProps): JSX.Element => {
    const { settings } = useKnownPanels();
    const eventsTitle = SETTINGS_NAV_TITLES[SettingsPaths.eventManagement];
    const eventManagementDisplayDescription = SETTINGS_NAV_DESCRIPTIONS_PATCH[SettingsPaths.eventManagement];

    const searchInput = (
        <RVDebouncedInput
            action={setFilterValue}
            placeholder="Search by Event Name"
            size="middle"
            data-testid="search-event-name"
            defaultValue={filterValue}
        />
    );

    return (
        <RVNestedPageHeader
            title={eventsTitle}
            subtitle={eventManagementDisplayDescription}
            prefix={<ToggleCollapsiblePanelButton panelName={settings.name} direction="left" />}
            actionRowLeft={searchInput}
        />
    );
};
